import React, { useState } from 'react';
import { supabase } from '../lib/supabase';

const SiteBuilder = () => {
  const [formData, setFormData] = useState({
    clientName: '',
    clientEmail: '',
    liveDomain: '',
    monthlyFee: 29.99
  });
  const [creating, setCreating] = useState(false);

  const generateRepoName = (name) => {
    return `awd-client-${name.toLowerCase().replace(/[^a-z0-9 ]/g, '').replace(/\s+/g, '-')}`;
  };

  const createClientSite = async (e) => {
    e.preventDefault();
    setCreating(true);

    try {
      const { data: { user } } = await supabase.auth.getUser();
      const repoName = generateRepoName(formData.clientName);

      const { error } = await supabase
        .from('clients')
        .insert([{
          name: formData.clientName,
          domain: `${repoName}.pages.dev`,
          staging_domain: null,
          live_domain: formData.liveDomain || null,
          repository_name: repoName,
          admin_user_id: user.id,
          monthly_fee: formData.monthlyFee,
          status: 'active',
          staging_status: 'draft',
          is_published: false
        }]);

      if (error) throw error;

      alert(`Client ${formData.clientName} created successfully!`);
      setFormData({clientName: '', clientEmail: '', liveDomain: '', monthlyFee: 29.99});
      
    } catch (error) {
      alert('Error: ' + error.message);
    } finally {
      setCreating(false);
    }
  };

  return (
    <div className="space-y-6">
      <div className="bg-gradient-to-r from-indigo-600 to-purple-600 rounded-lg p-6 text-white">
        <h2 className="text-2xl font-bold mb-2">Create New Client Site</h2>
        <p className="text-indigo-100">Set up a new professional website in minutes</p>
      </div>

      <div className="bg-white shadow sm:rounded-lg">
        <div className="px-6 py-6">
          <form onSubmit={createClientSite} className="space-y-6">
            <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Client Name</label>
                <input
                  type="text"
                  value={formData.clientName}
                  onChange={(e) => setFormData({...formData, clientName: e.target.value})}
                  required
                  className="block w-full border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 px-3 py-2 border"
                  placeholder="Acme Corporation"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Client Email</label>
                <input
                  type="email"
                  value={formData.clientEmail}
                  onChange={(e) => setFormData({...formData, clientEmail: e.target.value})}
                  required
                  className="block w-full border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 px-3 py-2 border"
                  placeholder="client@example.com"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Live Domain (Optional)</label>
                <input
                  type="text"
                  value={formData.liveDomain}
                  onChange={(e) => setFormData({...formData, liveDomain: e.target.value})}
                  className="block w-full border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 px-3 py-2 border"
                  placeholder="example.com"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Monthly Fee ($)</label>
                <input
                  type="number"
                  step="0.01"
                  min="0"
                  value={formData.monthlyFee}
                  onChange={(e) => setFormData({...formData, monthlyFee: parseFloat(e.target.value) || 0})}
                  className="block w-full border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 px-3 py-2 border"
                />
              </div>
            </div>

            <div className="flex justify-end">
              <button
                type="submit"
                disabled={creating || !formData.clientName || !formData.clientEmail}
                className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 disabled:opacity-50"
              >
                {creating ? 'Creating...' : 'Create Client Site'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SiteBuilder;
